<template>
  <div id="app">
    <kendo-notification ref="popupNotification" :position-top="300" stacking="down"></kendo-notification>
    <component :is="addLayout">
      <router-view />
    </component>
  </div>
</template>

<script>
const defaultLayout = "defaultlayout";
export default {
  name: "App",
  computed: {
    addLayout() {
      return this.$route.meta.layout || defaultLayout;
    }
  },
  watch: {
    $route(to) {
      document.title = to.meta.title || "Trackervigil";
    }
  },
  methods: {
    showPopupNotification: function(payload) {
      this.popupNotificationWidget.show(
        payload.message,
        payload.type || "info"
      );
    }
  },
  created() {},
  beforeDestroy() {},
  async mounted() {
    // TODO load all products data /combine the initial data
    // await this.$store.dispatch("loadSettings");
    await this.$store.dispatch("getProduct");
    await this.$store.dispatch("getPackage");
    await this.$store.dispatch("getFeature");
    await this.$store.dispatch("getInitialData");
    await this.$store.dispatch("getYear");
    this.popupNotificationWidget = this.$refs.popupNotification.kendoWidget();
    this.$store.subscribe(mutation => {
      if (mutation.type == "notify") {
        this.showPopupNotification(mutation.payload);
      }
    });
  }
};
</script>
